import defaultUserImage from '../../../static/images/avatar.png';
import { getCookieByName } from '../../utils';


const User = class {
  constructor(data = {}, token = '') {
    this.raw = data;
    this.rawtoken = token;
  }

  static get token() {
    return getCookieByName('accessToken');
  }

  set token(value) {
    this.accessToken = value;
  }

  get uid() {
    return this.raw.uid;
  }

  get refreshToken() {
    return this.raw ? this.raw.refreshToken : '';
  }

  get fullName() {
    return this.raw ? this.raw.displayName : '';
  }

  get email() {
    return this.raw ? this.raw.email : '';
  }

  get photoSrc() {
    return this.raw ? this.raw.photoURL : defaultUserImage;
  }
};

export default User;



// WEBPACK FOOTER //
// ./src/store/models/user.js